import React from 'react';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';
import { Button } from 'components/ui/button';
import { Form } from 'react-bootstrap-5';

export class SavedSearchForm extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  state = {
    name: ''
  }

  handleInput = e => this.setState({ name: e.target.value });

  render() {
    const { name } = this.state;
    const { onSave, onCancel } = this.props;
    const disabledSave = isBlank(name);
    return (
      <div className="p-1">
        <Form.Group className="mb-3">
          <Form.Label>Save this Search As:</Form.Label>
          <Form.Control
            placeholder="Enter a name"
            type="text"
            value={name}
            onChange={this.handleInput}
          />
        </Form.Group>

        <div className="d-flex gap-2">
          <Button className="ms-auto" label="Cancel" size="sm" variant="ghost" onClick={onCancel} />
          <Button disabled={disabledSave} size="sm" onClick={() => onSave(name)}>
            Save
          </Button>
        </div>
      </div>
    );
  }
}
